import { createAsyncAction } from 'redux-promise-middleware-actions';
import api from '../api/apiSettings';
import configData from '../config.json';

export const types = {
  GET_LANGUAGES: 'GET_LANGUAGES',
  GET_LANGUAGES_FULFILLED: 'GET_LANGUAGES_FULFILLED'
};

export const getLanguages = createAsyncAction(types.GET_LANGUAGES, () =>
  api.get(`${configData.REACT_APP_PUBLIC_URL}/locales/languages.json`).then((data) => data)
);
